import React from "react";
import { Link } from "react-router-dom";

const Footer = (isAuthenticated, onLogout) => (
  <footer>
    <p style={{ margin: "0 auto", textAlign: "center" }}>2020 Jared Hinkle</p>
    <ul className="App-header container">
      <li key="home">
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/episodes">Episodes</Link>
      </li>
    </ul>
  </footer>
);

export default Footer;
